import HttpClient from 'httpClient';

export function getDestinations() {
  return HttpClient.get('/wp-json/tripx/v1/destinations');
}
